import styled from 'styled-components';
import { useCallback } from 'react';
import { Button } from '../Button';
import { useResendVerifyEmail } from './useResendVerifyEmail';

const StyledButton = styled(Button)`
  min-width: 140px;
`;

export const ResendVerifyEmailButton = ({ variant = 'primary', ...others }) => {
  const { resendVerifyEmail, countDown } = useResendVerifyEmail();

  const onResendEmailButtonClick = useCallback(() => {
    if (countDown > 0) {
      return;
    }
    resendVerifyEmail();
  }, [countDown, resendVerifyEmail]);

  return (
    <StyledButton
      variant={variant}
      onClick={onResendEmailButtonClick}
      {...others}
    >
      {countDown > 0 ? `${countDown}秒` : '重发验证邮件'}
    </StyledButton>
  );
};
